{
  "CHAT_LIST": {
    "LOADING": "Henter samtaler",
    "LOAD_MORE_CONVERSATIONS": "Last inn flere samtaler",
    "EOF": "Alle samtaler lastet 🎉",
    "LIST": {
      "404": "Det er ingen aktive samtaler i denne gruppen."
    },
    "FAILED_TO_SEND": "Kunne ikke sende",
    "TAB_HEADING": "Samtaler",
    "MENTION_HEADING": "Omtale",
    "UNATTENDED_HEADING": "Udeltatt",
    "SEARCH": {
      "INPUT": "Søk etter personer, samtaler, lagrede svar .."
    },
    "FILTER_ALL": "Alle",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Mine",
      "unassigned": "Ikke tildelt",
      "all": "Alle"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Åpne"
      },
      "resolved": {
        "TEXT": "Løst"
      },
      "pending": {
        "TEXT": "Ventende"
      },
      "snoozed": {
        "TEXT": "Slumret"
      },
      "all": {
        "TEXT": "Alle"
      }
    },
    "VIEW_FILTER": "Vis",
    "SORT_TOOLTIP_LABEL": "Sorter samtaler",
    "CHAT_SORT": {
      "STATUS": "Satus",
      "ORDER_BY": "Order by"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": {
        "LATEST": "Created",
        "OLDEST": "Created at:"
      },
      "LAST_ACTIVITY": {
        "NOT_ACTIVE": "Last activity:",
        "ACTIVE": "Last activity"
      }
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      },
      "priority_desc_created_at_asc": {
        "TEXT": "Priority: Highest first, Created: Oldest first"
      },
      "unread": {
        "TEXT": "Unread Count: Highest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Bildemelding"
      },
      "audio": {
        "CONTENT": "Lydmelding"
      },
      "video": {
        "CONTENT": "Video beskjed"
      },
      "file": {
        "CONTENT": "Vedlegg"
      },
      "location": {
        "CONTENT": "Plassering"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "har delt en URL"
      },
      "contact": {
        "CONTENT": "Shared contact"
      },
      "embed": {
        "CONTENT": "Embedded content"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sort conversation",
      "DROPDOWN_TITLE": "Sort by",
      "ITEMS": {
        "LATEST": {
          "NAME": "Last activity at",
          "LABEL": "Last activity"
        },
        "CREATED_AT": {
          "NAME": "Created at",
          "LABEL": "Created at"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Last user message at",
          "LABEL": "Last message"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Mottatt via e-post",
    "VIEW_TWEET_IN_TWITTER": "Vis tweet i Twitter",
    "REPLY_TO_TWEET": "Svar på denne tweeten",
    "LINK_TO_STORY": "Go to instagram story",
    "SENT": "Sent successfully",
    "READ": "Read successfully",
    "DELIVERED": "Delivered successfully",
    "NO_MESSAGES": "Ingen meldinger",
    "NO_CONTENT": "No content available",
    "HIDE_QUOTED_TEXT": "Hide Quoted Text",
    "SHOW_QUOTED_TEXT": "Show Quoted Text",
    "MESSAGE_READ": "Read",
    "SENDING": "Sending",
    "UNREAD_COUNT_OVERFLOW": "9+"
  }
}
